import { copyToClipboard } from "../../lib/clipboard";
import Swal from "sweetalert2";
import useBoolean from "../../hooks/useBoolean";

interface VideoCardProps {
    title: string;
    href: string;
    img: string;
    duration: string;
    dateDiff: string;
}

export default function VideoCard({
    title,
    href,
    img,
    duration,
    dateDiff,
}: VideoCardProps) {
    const [isHidden, hide] = useBoolean();

    if (isHidden) {
        return <></>;
    }

    function handleClick() {
        copyToClipboard(href);
        Swal.fire({
            title: "Link Copiado!",
            text: "Vídeo copiado com sucesso, agora basta enviar para o Robozinho no Telegram!",
            color: "#ffffff",
            background: "#121212",
            confirmButtonText: "Abrir o Robozinho",
            confirmButtonColor: "#f00000",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.value) {
                const a = document.createElement("a");
                a.href = "https://t.me/RobozinhoDoXVIDEOS_BOT";
                a.target = '_blank'
                a.style.visibility = "hidden";

                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        });
    }

    return (
        <li className="w-full">
            <button
                onClick={handleClick}
                className="flex w-full flex-col gap-1 hover:underline"
            >
                <img
                    className="aspect-video w-full rounded-sm transition-all hover:rounded-none"
                    src={img}
                    onError={hide}
                    alt="Miniatura do Vídeo"
                />
                <h3 className="text-lg font-medium">{title}</h3>
                <div className="text-sm">
                    <span>{duration}</span>
                    <span> • </span>
                    <span>{dateDiff}</span>
                </div>
            </button>
        </li>
    );
}
